import PortalIdParser from 'PortalIdParser';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { Flex } from 'foundations-components/components/Flex';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHasPortalScope, useHasScope } from '../../accounts/accountsQueries';
import { isInternalContent } from '../../learningContent/utils';
import { getStudioContentUrl } from '../../learningContent/getStudioContentUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STUDIO_LMS_SCOPE = 'academy-studio-lms-content-write';
const CardMenuOpenInStudioOption = ({
  item,
  onClose,
  render
}) => {
  const portalId = PortalIdParser.getPortalIdFromPath();
  const {
    hasPortalScope
  } = useHasPortalScope(portalId !== null && portalId !== void 0 ? portalId : undefined, STUDIO_LMS_SCOPE);
  const {
    hasScope
  } = useHasScope(STUDIO_LMS_SCOPE);
  const studioUrl = getStudioContentUrl(item);
  if (!isInternalContent(item) || !hasPortalScope || !hasScope || !studioUrl) {
    return null;
  }
  const handleClick = () => {
    window.open(studioUrl, '_blank', 'noopener,noreferrer');
    onClose === null || onClose === void 0 || onClose();
  };
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.cardMenu.openInStudio"
  });
  if (render) {
    return render(label, handleClick);
  }
  return /*#__PURE__*/_jsx(SideNavItem, {
    onClick: handleClick,
    role: "navigation-item",
    title: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      inlineSize: "100%",
      justifyContent: "space-between",
      children: [label, /*#__PURE__*/_jsx(ExternalLinkIcon, {
        color: "icon-interactive-default",
        size: "100"
      })]
    })
  });
};
export default CardMenuOpenInStudioOption;